import { secondaryLighter } from "../../assets/js/mcn-helpers";
export default {
  name: "PurchaseGiftSVG",
  props: {
    data: Object
  },
  computed: {
    primary() {
      var _this$data$primaryCol, _this$data;
      return (_this$data$primaryCol = (_this$data = this.data) === null || _this$data === void 0 ? void 0 : _this$data.primaryColor) !== null && _this$data$primaryCol !== void 0 ? _this$data$primaryCol : '#407BFB';
    },
    secondary() {
      var _this$data$secondaryC, _this$data2;
      return (_this$data$secondaryC = (_this$data2 = this.data) === null || _this$data2 === void 0 ? void 0 : _this$data2.secondaryColor) !== null && _this$data$secondaryC !== void 0 ? _this$data$secondaryC : '#407BFB';
    },
    agentGift() {
      return secondaryLighter(this.secondary);
    },
    basketOnTheWall() {
      return secondaryLighter(this.secondary);
    }
  }
};